import { moduleMap, questionTypeMap } from '@/constant'
import { zoneEnMap } from '@/view/undergraduate/mentee/constants'
import { zone } from '@/constant/mentor'
export const mentorTypeTitle = type => {
  let title = ''
  switch (type) {
    case 'SM':
      title = 'School Mentor'
      break
    case 'EM':
      title = 'Editor Mentor'
      break
    case 'CM':
      title = 'Career Mentor'
      break
    case 'UGDCM':
      title = 'College Mentor'
      break
    case 'UGDEM':
      title = 'Essay Mentor'
      break
    case 'UGDFAO':
      title = 'FAO Mentor'
      break
  }
  return title
}
// 待办事项
export const todaMap = value => {
  let name = ''
  switch (value) {
    case 'MODULE_1':
      name = 'KIK'
      break
    case 'MODULE_2':
      name = 'PS'
      break
    case 'MODULE_3':
      name = 'EB'
      break
    case 'MODULE_8':
    case 'MODULE_7':
      name = 'CS'
      break
    case 'INTERVIEW':
      name = ''
      break
    case 'MODULE_20':
      name = ''
      break
  }
  return name
}
// 模板映射
export const moduleTitleMap = value => {
  if (!value) return ''
  return moduleMap.filter(item => item.value === value)[0]['title']
}
// 时区映射
export const zoneTitleMap = value => {
  if (!value) return ''
  return zone.filter(item => item.value === value)[0]['title']
}
// 代办事项 - title
export const todoStatusTitleMap = status => {
  let title = ''
  switch (status) {
    case 'TO_BE_COMPLETE_MENTOR':
      title = 'Please confirm the time'
      break
    case 'TO_BE_COMPLETE_MENTEE':
      title = 'Waiting for mentee confirming time'
      break
    case 'INCOMPLETE':
      title = 'Appointment time has been confirmed, please attend on time'
      break
    case 'SYSTEM_RECALL':
      title = 'CD withdrew'
      break
    case 'RECALL':
      title = 'Automatically shut down'
      break
    case 'TO_FEEDBACK':
      title = 'Please fill in the feedback and the time spent'
      break
    case 'COMPLETE':
    case 'HAS_EVALUATE':
      title = 'Complete'
      break
  }
  return title
}
// 代办事项 - color
export const todoStatusColorMap = status => {
  let color = ''
  switch (status) {
    case 'COMPLETE':
    case 'TO_BE_COMPLETE_MENTEE':
    case 'TO_FEEDBACK':
      color = 'orange'
      break
    case 'TO_BE_COMPLETE_MENTOR':
    case 'INCOMPLETE':
      color = 'green'
      break
    case 'RECALL':
    case 'HAS_EVALUATE':
    case 'SYSTEM_RECALL':
      color = 'gray'
      break
  }
  return color
}
// 问题反馈类型 title
export const questionTypeTitleMap = type => {
  if (!type) return ''
  return questionTypeMap.filter(item => item.value === type)[0]['title']
}
// 填充 0
export const fillZero = num => {
  return num < 10 ? `0${num}` : num
}

export const timeZoneEnFilter = zone => {
  let find = zoneEnMap.find(o => o.value === zone)
  if (find) {
    return find.title
  }
  return ''
}
